import React, { Component } from 'react'
import { connect } from 'react-redux';
import { getPostCommenrts } from '../../../../core/actions/postGet'

class GridPost extends Component {
    render() {

  const { detail } = this.props
  return (
      <div className="col-sm-6">
        <div className="single-blog">
          <div className="image"><img src={detail.image} alt={detail.slug} /></div>
          <ul>
            <li>
              <i className="flaticon-comments"></i>
              <a href="#" className="tran3s">{detail.commentsNo}</a>
            </li>
            <li>
              <i className="flaticon-heart"></i>
              <a href="#" className="tran3s">{detail.likes}</a>
            </li>
          </ul>
          <h4><a href={`/blog/${detail.slug}`} className="tran3s">{detail.title}</a></h4>
          <p dangerouslySetInnerHTML={{ __html: detail.content.substring(0, 150) + '...' }}></p>
          <a href={`/blog/${detail.slug}`} className="tran3s">Read More</a>
        </div>
      </div>
    )
  }
}

export default GridPost